function customCartBtn() {
  // selling_plan_id : 691215728982 ( 90 day supply )
  // selling_plan_id : 691215827286 ( 30 day supply )
  var $form = $('.product-form form').first();
$form.find('.custom-cart-item').remove();
var sellingPlan = $form.find('[name="selling_plan"]').val();
if(!sellingPlan){
  sellingPlan = '';
}
$('.product-form__input--pill input[type="radio"]:checked').each(function () {
  var id = $(this).attr('id');

  if ($(this).attr('selling_plan') == '11152124') {
    sellingPlan = '691215728982';
  } else if ($(this).attr('selling_plan') == '11152127') {
    sellingPlan = '691215827286';
  } else {
    sellingPlan = '';
  }
  if(sellingPlan!=''){
    $('<input>', {
      type: 'hidden',
      name: 'selling_plan',
      value: sellingPlan,
      class: 'custom-cart-item'
    }).appendTo($form);
  }
  var $label = $('label[for="' + id + '"]');
  $label.find('.gift-product').each(function () {
    var variant = $(this).attr('variant');
    if (variant) {
      var index = $form.find('.custom-cart-item[name$="[id]"]').length + 1;
      $('<input>', {
        type: 'hidden',
        name: 'items[' + index + '][id]',
        value: variant,
        class: 'custom-cart-item'
      }).appendTo($form);
      $('<input>', {
        type: 'hidden',
        name: 'items[' + index + '][quantity]',
        value: 1,
        class: 'custom-cart-item'
      }).appendTo($form);
    }

  });

});
   let $buttonSubs = $('.product-form__submit').first();
    if ($buttonSubs.length) {
      $buttonSubs.trigger('click');
    }
}

      const pf = document.querySelector('.product-form__buttons');
      const cs = document.querySelector('.customSubCart');
      const btn = pf?.querySelector('button[name="add"]');

      function update() {
        const text = btn?.querySelector('span');
        if (!btn || !cs) return;

        cs.innerHTML = text?.innerHTML || '';
        cs.toggleAttribute('disabled', btn.disabled);
      }

      update();

      new MutationObserver(update).observe(btn, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled']
      });

document.addEventListener('click', function (e) {
  const title = e.target.closest('[data-future-toggle]');
  if (!title) return;
  const futureGifts = title.closest('.future-gifts');
  if (!futureGifts) return;
  futureGifts.classList.toggle('is-open');
});

$(document).on('click', '.blossom-options.one-time', function () {
  let $form = $('.product-form form').first();
  $form.find('.custom-cart-item').remove();
  let variant = $(this).attr('variant');
  $form.find('.product-variant-id').val(variant);
  let $button = $('.product-form__submit').first();
  if ($button.length) {
    $button.trigger('click');
  }
});